import { Grid } from '@mui/material'
import Label from 'components/Label'
import React from 'react'
import { TabTeenagerProps } from '../..'
import { HearingIdentificationType } from 'types/hearing-identification.type'
import { useFormContext } from 'react-hook-form'
import FormControlRadio, { radioButtonChoiceOptions } from 'components/FormControlRadio'
import { InstitutionallyWelcomedGroup } from 'pages/CreateHearing/components/StepIdentification/components/InstitutionallyWelcomedGroup'

export const TabWelcome: React.FC<TabTeenagerProps> = () => {
  const { control, watch, setValue, setError, clearErrors } =
    useFormContext<HearingIdentificationType>()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Label text='Dados de acolhimento' v='h6' color='primary' bold />
      </Grid>
      <Grid item lg={12} md={12} xs={12}>
        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <Grid item md={12}>
            <FormControlRadio
              control={control}
              name='identificacaoAdolescente.situacaoRua'
              label='Está ou já esteve em situação de rua?'
              options={radioButtonChoiceOptions}
            />
          </Grid>
        </Grid>

        <Grid container spacing={2} rowSpacing={4} sx={{ mb: 4 }}>
          <InstitutionallyWelcomedGroup control={control} watch={watch} setValue={setValue} />
        </Grid>
      </Grid>
    </Grid>
  )
}
